import { ReactNode, useState } from "react";
import {
  Path,
  FieldError,
  Control,
  Controller,
  FieldValues,
} from "react-hook-form";
import { CustomAxiosRequestConfig, axiosPrivate } from "../../api/axios";
import MoonLoader from "react-spinners/MoonLoader";
import { toast } from "react-toastify";
import { USER_ADDRESS_INQUIRY } from "../../api/apiClient";

export type InputComponentProps<Type extends FieldValues> = {
  APIgetValue?: string | number;
  label?: string;
  btnText?: string;
  placeholder?: string;
  helperText?: string;
  success?: boolean;
  errors?: FieldError;
  disabled?: boolean;
  btnDisabled?: boolean;
  inputIcon?: ReactNode;
  onChange?: (value: string | number) => void;
  value?: any;
  type?: any;
  name: Path<Type>;
  control?: Control<Type, any>;
  maxLength?: number;
  direction?: "ltr" | "rtl";
  setValue?: any;
  editable?: boolean;
  onValueReceived?: (value: string) => void;
  setState?: any;
};
function InputPlusButton<Type extends FieldValues>(
  props: InputComponentProps<Type>
) {
  const [isFocused, setIsFocused] = useState(false);
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [isSubmitingBtn, setIsSubmitingBtn] = useState(false);
  const access_token = localStorage.getItem("access_token");
  const [inputValue, setInputValue] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);

  const [btnStyle, setBtnStyle] = useState<string>(
    isSubmitingBtn || props.btnDisabled
      ? "text-gray-400 cursor-not-allowed absolute py-[6px] end-2 bottom-[5px] w-[48px] h-[34px] ml-3 transition-transform transform "
      : "text-primary-800 font-bold absolute cursor-pointer py-[6px] end-2 bottom-[5px]  w-[48px] h-[34px] ml-3"
  );
  const getInputClassName = () => {
    if (props.success) {
      return ` text-green-600 border-green-500 bg-green-100 focus:text-green-700`;
    } else if (props.errors) {
      return ` text-red-600 border-red-500 bg-red-100 focus:text-red-700`;
    } else if (props.disabled) {
      return ` cursor-not-allowed  opacity-50`;
    } else {
      return ` focus:text-gray-900 bg-gray-50 text-gray-900 border-gray-300`;
    }
  };

  const getSvgClassName = () => {
    if (props.errors) {
      return "text-red-700"; // Error state
    } else if (isFocused) {
      return "text-primary-700"; // Focus state
    } else if (props.disabled || props.editable === false) {
      return "text-gray-400"; // Disabled state
    } else {
      return "text-gray-700"; // Default state
    }
  };

  const getAddressInfo = async () => {
    setIsSubmitingBtn(true);
    setIsLoadingBtn(true);
    setBtnStyle(
      "text-gray-400 cursor-not-allowed absolute py-[6px] end-2 bottom-[5px] rounded-[5px] w-[48px] h-[34px] transition-transform transform ml-3"
    );

    try {
      const response = await axiosPrivate.get(
        USER_ADDRESS_INQUIRY(inputValue),

        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );

      if (response?.status >= 200 && response?.status < 300) {
        setIsSubmitingBtn(false);
        setIsLoadingBtn(false);
        setDisableBtn(true);

        setBtnStyle(
          "text-primary-800 font-bold absolute  py-[6px] cursor-pointer end-2 bottom-[5px] rounded-[5px] w-[48px] h-[34px] ml-3"
        );
        // if (props.onValueReceived) {
        //   props.onValueReceived(() => response.data?.data?.address);
        // }
        if (props.onValueReceived) {
          props.onValueReceived(response.data?.data?.address);
        }
      } else {
        setIsSubmitingBtn(false);
      }
    } catch (error) {
      setIsSubmitingBtn(false);
      setIsLoadingBtn(false);
      setDisableBtn(true);

      if (props.onValueReceived) {
        props.onValueReceived("");
        toast.error(
          "متاسفانه در حال حاضر این سرویس از سمت ارائه دهنده غیر فعال است."
        );
      }

      setBtnStyle(
        "text-primary-800 font-bold absolute  py-[6px] cursor-pointer end-2 bottom-[5px] rounded-[5px] w-[48px] h-[34px] ml-3"
      );
    }
  };
  return (
    <>
      {isLoadingBtn ||
        (isSubmitingBtn && (
          <div className="flex  justify-center items-center inset-0 absolute  z-10">
            <div className="bg-gray-100 opacity-20 absolute w-screen h-screen" />
            <MoonLoader color="#477CD1" />
          </div>
        ))}
      <Controller
        name={props.name}
        control={props.control}
        render={({ field }) => (
          <div className="flex flex-col justify-between">
            <div className="relative">
              <div
                className={`absolute top-0 bottom-0 right-0 flex items-center ps-3 pointer-events-none ${getSvgClassName()}`}
              >
                {props.inputIcon}
              </div>
              <input
                disabled={isSubmitingBtn ? true : false}
                defaultValue={props.APIgetValue}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                dir={props.direction || "rtl"}
                type={props.type}
                id=""
                className={`${getInputClassName()} block w-full pr-8 ${
                  props.direction ? "px-[80px]" : "px-4"
                }  py-2 border rounded-lg focus:outline-none focus:border-primary-700  h-[44px] focus:text-gray-900 bg-gray-50 text-gray-900 border-gray-300`}
                onChange={(e) => {
                  setInputValue(e.target.value);
                  const value =
                    props.type === "number"
                      ? Number(e.target.value.replace(/[^0-9]/g, ""))
                      : e.target.value;
                  if (
                    props.maxLength &&
                    value.toString()?.length > props.maxLength
                  ) {
                    return;
                  }
                  field.onChange(value);
                  if (props.onChange) props.onChange(value);
                  const newBtnStyle =
                    isSubmitingBtn || e.target.value.length === 10
                      ? "text-primary-800 font-bold absolute  py-[6px] cursor-pointer end-2 bottom-[5px] rounded-[5px] w-[48px] h-[34px] ml-3"
                      : "text-gray-400 cursor-not-allowed absolute py-[6px] end-2 bottom-[5px] rounded-[5px] w-[48px] h-[34px] transition-transform transform ml-3";
                  setBtnStyle(newBtnStyle);
                  isSubmitingBtn || e.target.value.length === 10
                    ? setDisableBtn(true)
                    : setDisableBtn(false);
                }}
                onKeyPress={(e) => {
                  if (
                    props.type === "tel" &&
                    !/^\d$/.test(e.key) &&
                    e.key !== "Enter" &&
                    e.keyCode !== 13
                  ) {
                    e.preventDefault();
                  }
                }}
                maxLength={props.maxLength}
              />

              {/* <span className={btnStyle} onClick={() => getAddressInfo()}>
                {isLoadingBtn ? (
                  <div className="flex  justify-center items-center inset-0 absolute  z-10">
                    <div className="bg-gray-100 opacity-20 absolute w-1 h-1" />
                    <MoonLoader color="#477CD1" size={20} />
                  </div>
                ) : (
                  props.btnText
                )}
              </span> */}
            </div>
            {props.errors && props.errors.message ? (
              <p className={`text-Body-OneLine/14/Regular text-red-600`}>
                {props.errors.message}
              </p>
            ) : (
              <p className={`text-Body-OneLine/14/Regular text-gray-500`}>
                {props.helperText ? (
                  props.helperText
                ) : (
                  <span className="invisible">invisible</span>
                )}
              </p>
            )}
          </div>
        )}
      />
    </>
  );
}

export default InputPlusButton;
